import getStore from '../store/configureStore';
import _get from 'lodash/get';

export function getNextStep(currentStep) {
  const totalSteps = 4;
  if (currentStep < totalSteps) {
    return currentStep + 1;
  }
  return 1;
}

export function getPreviousStep(currentStep) {
  if (currentStep > 1) {
    return currentStep - 1;
  }
  return 1;
}

export const isGuestFormPreview = (currentStep) => currentStep === 3;

export function getCharityName() {
  const reduxStore = getStore();
  return _get(reduxStore.getState(), 'application.receiverName');
}

export const isCampaignEnded = (endDate) => {
  if (!(endDate instanceof Date && !isNaN(endDate))) {
    return false;
  }
  return new Date().setHours(0, 0, 0, 0) > endDate.setHours(0, 0, 0, 0);
};

export const isCampaign = (type) => {
  return window?.location?.href?.indexOf('campaigns') > -1;
};
